export function shipmentShowValidate(shipment){
    var result = true;

    result = validateId(shipment.id);
    result = validateUniqueOrderNumber(shipment.uniqueOrderNumber);
    // result = validateShipmentNumber(shipment.shipment_number);
    // result = validateShippingService(shipment.shipping_service);
    // result = validateTotal(shipment.total);
    // result = validateShippingPrice(shipment.shipping_price);
    // result = validateInvoice(shipment.invoice);
    // result = validateTotalWeight(shipment.total_weight);
    // result = validateLabelDownload(shipment.label_download);
    // result = validateNoteDownload(shipment.note_download);
    // result = validateIsRfid(shipment.is_rfid);
    // result = validateCod(shipment.cod);
    // result = validateCreatedAt(shipment.created_at);
    // result = validateClientId(shipment.client_id);
    // result = validateBoxId(shipment.box_id);
    // result = validateConsigneeId(shipment.consignee_id);
    // result = validateCharge(shipment.charge);
    // result = validateClient(shipment.client);
    // result = validateShipmentProductDetail(shipment.shipment_product_detail);
    // result = validateOrderStatus(shipment.order_status);
    // result = validateConsignee(shipment.consignee);

    return result;
}

function validateId(id) {    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateUniqueOrderNumber(unique_order_number) {
    if(typeof unique_order_number === 'string' && unique_order_number.trim() !== '') return true;
    else return false;
}

// function validateShipmentNumber(shipment_number) {
//     if(typeof shipment_number === 'string' && shipment_number.trim() !== '') return true;
//     else return false;
// }

// function validateShippingService(shipping_service) {
//     if(typeof shipping_service === 'string' && shipping_service.trim() !== '') return true;
//     else return false;
// }

// function validateTotal(total) {
//     if(/^([1-9]\d*|0)(\.\d+)?$/.test(total)) return true;
//     else {
//         return false;
//     }
// }

// function validateShippingPrice(shipping_price) {
//     if( shipping_price == null) return true;
//     else if(/^([1-9]\d*|0)(\.\d+)?$/.test(shipping_price)) return true;
//     else {
//         return false;
//     }
// }

// function validateInvoice(invoice) {
//     if(typeof invoice === 'string' && invoice.trim() !== '') return true;
//     else return false;
// }

// function validateTotalWeight(total_weight) {
//     if(total_weight == null) return true;
//     else if(/^([1-9]\d*|0)(\.\d+)?$/.test(total_weight)) return true;
//     else {
//         return false;
//     }
// }

// function validateLabelDownload(label_download) {
//     if(typeof label_download === "boolean") return true;
//     else return false;
// }

// function validateNoteDownload(note_download) {
//     if(typeof note_download === "boolean") return true;
//     else return false;
// }

// function validateIsRfid(is_rfid) {
//     if(typeof is_rfid === "boolean") return true;
//     else return false;
// }

// function validateCod(cod) {
//     if(typeof cod === "boolean") return true;
//     else return false;
// }

// function validateCreatedAt(created_at) { 
//     if(typeof created_at === 'string' && created_at.trim() !== '') return true;
//     else return false;
// }
// function validateClientId(client_id) {
//     if(Number.isInteger(client_id)) return true;
//     else return false;
// }

// function validateBoxId(box_id) {
//     if(box_id == null) return true;
//     else if(Number.isInteger(box_id)) return true;
//     else return false;
// }

// function validateConsigneeId(consignee_id) { 
//     if(consignee_id == null) return true;
//     else if(Number.isInteger(consignee_id)) return true;
//     else return false;
// }

// function validateCharge(charge) {
//     if(charge == null) return false;
//     else {
//         return typeof charge === 'object' && 
//         typeof charge.id === "number" &&
//         typeof charge.status === "string" &&
//         typeof charge.paid_at === "string" &&
//         typeof charge.last_status === "string" &&
//         typeof charge.last_updated_at === "string" &&
//         typeof charge.cutoff_id === "number" 
//     }
// }

// function validateClient(client) {
//     if(client == null) return true;
//     else {
//         return typeof client === 'object' && 
//         typeof client.id === "number" &&
//         typeof client.name === "string" &&
//         typeof client.rfid_by_product === "boolean" &&
//         typeof client.client_type === "string" &&
//         typeof client.guides_service === "boolean"
//     }
// }

// function validateShipmentProductDetail(pd) {
//     if(pd == null) return true;
//     else {
//         return typeof pd === 'object' && 
//         typeof pd.quantity === "number" &&
//         typeof pd.is_kit === "boolean" &&
//         typeof pd.unit_price == "number" &&
//         typeof pd.subtotal == "number" &&
//         typeof pd.product == "object" &&
//         typeof pd.product.id === "number" &&
//         typeof pd.product.sku === "string" &&
//         typeof pd.product.description === "string"
//     }
// }

// function validateOrderStatus(status) {
//     if(status == null) return true;
//     else {
//         return typeof status === 'object' && 
//         typeof status.status === "string" &&
//         typeof status.current === "boolean" &&
//         (typeof status.date === "string" || status.date == null) &&
//         (typeof status.time === "string" || status.time == null) &&
//         typeof status.created_at === "string" 
//     }
// }

// function validateConsignee(consignee) {
//     if(consignee == null) return true;
//     else {
//         return typeof consignee === 'object' && 
//         typeof consignee.id === "number" &&
//         typeof consignee.name === "string" &&
//         typeof consignee.country === "string" &&
//         typeof consignee.state === "string" &&
//         typeof consignee.municipality === "string" &&
//         typeof consignee.neighborhood === "string" &&
//         typeof consignee.street === "string" &&
//         typeof consignee.external_number === "string" &&
//         (typeof consignee.internal_number === "string" || consignee.internal_number == null) &&
//         typeof consignee.zipcode === "string" &&
//         (typeof consignee.comments === "string" || consignee.comments == null) &&
//         typeof consignee.email === "string" &&
//         typeof consignee.phone === "string"

//     }
// }